import { Badge, Tooltip } from '@mantine/core';
import { FLAG_BADGE } from 'constants/mapping';

interface FlagBadgeProps {
  item: {
    asAddition?: boolean | null;
    asInstruction?: boolean | null;
    ignore?: boolean | null;
    replacesMain?: boolean | null;
  };
}

export default function FlagBadge({ item }: FlagBadgeProps) {
  const { asAddition, asInstruction, ignore, replacesMain } = item;

  if (!asAddition && !asInstruction && !ignore && !replacesMain) {
    return null;
  }

  function getFlagBadge() {
    if (asAddition) {
      return FLAG_BADGE.AS_ADDITION;
    }
    if (asInstruction) {
      return FLAG_BADGE.AS_INSTRUCTION;
    }
    if (ignore) {
      return FLAG_BADGE.IGNORE;
    }
    if (replacesMain) {
      return FLAG_BADGE.REPLACES_MAIN;
    }
  }

  function getFlagTooltip() {
    if (asAddition) {
      return 'This modifier is mapped as an item in your POS and added to orders as an additional item.';
    }
    if (asInstruction) {
      return 'This item or modifier is added as an instruction. No ID is mapped or sent to your POS.';
    }
    if (ignore) {
      return 'This item or modifier will not be sent to your POS and will be removed from orders.';
    }
    if (replacesMain) {
      return 'This modifier will replace the order item with the selected item in your POS.';
    }
  }

  return (
    <Tooltip label={getFlagTooltip()} position="left" w={220}>
      <Badge variant="outline" size="xs">
        {getFlagBadge()}
      </Badge>
    </Tooltip>
  );
}
